import React from 'react';

import Batches from 'app/collections/batches';
import DropdownSelections from 'app/collections/dropdown_selections';
import ApiModeSelection from 'app/models/api_mode_selection';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import DateAndTimeHeadingView from 'app/components/list/item/headings/date_and_time';
import PageHeader from 'app/components/page_header_react';
import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';

import tmpl from './template';

export const buildHeadings = () => [
  new Heading({
    subView: m => new DateAndTimeHeadingView({ model: m }),
    display: 'Date',
    xsSize: 4,
    smSize: 3,
    wrapperClass: 'text-nowrap',
  }),
  new Heading({
    text: m => m.get('state'),
    display: 'State',
    xsSize: 4,
    smSize: 4,
    wrapperClass: m => (m ? 'monospace-font' : ''),
  }),
  new Heading({
    text: m => m.get('num_shipments'),
    display: '# of Shipments',
    xsSize: 4,
    smSize: 3,
  }),
];

export const buildShowDetails = () => ({
  mainHeading: m => m.get('id'),
});

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'batches',

  initialize({ query = {} }) {
    this.apiModeSelection = new ApiModeSelection({});
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATETIME });
    this.dropdownSelections = new DropdownSelections(
      [this.apiModeSelection, this.dateRange],
      { initialChoices: query[this.className], urlParamKey: this.className },
    );
    this.collection = new Batches([], { dropdownSelections: this.dropdownSelections });

    this.listenTo(this.collection, 'update', this.render);

    this.addReactComponent(
      'header',
      <PageHeader
        name="Batches"
        links={[
          { name: 'Docs', href: '/docs/api#batches' },
          { name: 'Guide', href: '/batch-guide' },
        ]}
      />,
    );
    this.addSubview('apiModeSelector', '#api_mode_selector', new SelectorView({ model: this.apiModeSelection }));
    this.addSubview('datepickers', '#batch_daterange_pickers', new DatepickerRangeView({ model: this.dateRange }));
    this.addSubview('search', '#batch_search', new ListSearchView({
      collection: this.collection, placeholder: '(ID)', apiModeSelection: this.apiModeSelection,
    }));
    this.addSubview('batchList', '#batch_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No batches have been created matching your filter set.',
      showDetails: buildShowDetails(),
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/batches/index.jsx